const FILTERS = [
  { key: 'solution', label: 'Solution' },
  { key: 'color', label: 'Color' },
  { key: 'roomType', label: 'Room Type' },
  { key: 'product', label: 'Product' },
];

const selectedFilters = FILTERS.reduce((selected, filter) => {
  selected[filter.key] = [];
  return selected;
}, {});

const getItemValues = (item, key) => (
  (item[key] || '')
    .split(',')
    .map(value => value.trim())
    .filter(Boolean)
);

const getFilterOptions = (items, key) => (
  [...new Set(items.flatMap(item => getItemValues(item, key)))]
    .sort((a, b) => a.localeCompare(b))
);

const filterItems = items => (
  items.filter(item => (
    FILTERS.every(({ key }) => (
      selectedFilters[key].length === 0
      || selectedFilters[key].some(value => getItemValues(item, key).includes(value))
    ))
  ))
);

const setFilterSelected = (key, value, isSelected) => {
  if (!Object.prototype.hasOwnProperty.call(selectedFilters, key)) {
    return;
  }

  if (isSelected && !selectedFilters[key].includes(value)) {
    selectedFilters[key].push(value);
  } else if (!isSelected) {
    selectedFilters[key] = selectedFilters[key].filter(selected => selected !== value);
  }
};

const clearAllFilters = () => {
  FILTERS.forEach(({ key }) => {
    selectedFilters[key] = [];
  });
};

const replaceSelectedFilters = (nextFilters) => {
  FILTERS.forEach(({ key }) => {
    selectedFilters[key] = Array.isArray(nextFilters?.[key])
      ? [...nextFilters[key]]
      : [];
  });
};

const hasSelectedFilters = () => (
  FILTERS.some(({ key }) => selectedFilters[key].length > 0)
);

export {
  FILTERS,
  selectedFilters,
  getFilterOptions,
  filterItems,
  setFilterSelected,
  clearAllFilters,
  replaceSelectedFilters,
  hasSelectedFilters,
};
